import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length) return null;
  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid items-start gap-16 lg:grid-cols-12 lg:gap-y-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-8"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="border-t border-parchment/50 pt-8 lg:col-span-7 lg:col-start-6 lg:pl-10">
          <FormPanel
            errorMessage={errorMessage}
            fields={fields}
            submitLabel={submitLabel}
            successMessage={successMessage}
          />
        </div>
      </div>
    </VelvetSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
